<div class="members-root">
  <div class="members-header">
    <button type="button" class="members-back" (click)="onBack()">Back to chat</button>
    <div>
      <h1>Members</h1>
      <p>Assign an accepted organogram role to each tenant member. Roles come from Pre Req.</p>
    </div>
    <button type="button" class="members-refresh" (click)="reload()" [disabled]="isLoading">Refresh</button>
  </div>

  <div class="members-banner error" *ngIf="error">{{ error }}</div>
  <div class="members-banner info" *ngIf="info && !error">{{ info }}</div>

  <div class="members-loading" *ngIf="isLoading">Loading members&hellip;</div>

  <div class="members-empty" *ngIf="!isLoading && !members.length">
    No users are assigned to this tenant yet.
  </div>

  <div class="members-hint" *ngIf="!isLoading && members.length && !roles.length">
    No accepted organogram roles yet. Accept roles in Pre Req, then refresh.
  </div>

  <table class="members-table" *ngIf="!isLoading && members.length">
    <thead>
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th>Business role</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let member of members">
        <td>{{ member.fullName || '—' }}</td>
        <td>{{ member.email }}</td>
        <td>
          <select
            [(ngModel)]="draftRoleByUserId[member.userId]"
            [disabled]="savingUserId === member.userId || !roles.length">
            <option value="">None</option>
            <option *ngFor="let role of roles" [value]="role.id">{{ role.role }}</option>
          </select>
        </td>
        <td>
          <button
            type="button"
            class="members-save"
            (click)="save(member)"
            [disabled]="savingUserId === member.userId || (draftRoleByUserId[member.userId] || '') === (member.organogramRoleId || '')">
            {{ savingUserId === member.userId ? 'Saving…' : 'Save' }}
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
